import { Toast, HideForTestGroup } from 'packages/smart-home-support/components';
import { useCancelableEffect, useQueryParam, useToast } from 'packages/smart-home-support/hooks';
import { RequireUser } from 'packages/smart-home-support/pages/auth/components';
import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import TabNav, { TabNavProps } from './components/TabNav';
import { TabKey } from './models';
import { PageContainer, Heading1 } from './styles';
import { DevicesTab, HomeTab, SupportTab } from './tabs';
import { TestGroup } from 'packages/smart-home-support/models';

const tabs: TabNavProps<TabKey>['tabs'] = [
  {
    key: 'home',
    label: 'Home',
    Component: HomeTab,
  },
  {
    key: 'devices',
    label: 'My devices',
    Component: DevicesTab,
  },
  {
    key: 'support',
    label: 'Get help',
    Component: SupportTab,
  },
];

const ProfilePage: React.FC<RouteComponentProps> = (props) => {
  const [isToastVisible, triggerToast] = useToast();
  const [toastContent, setToastContent] = useState<React.ReactElement | string>('');
  const [tabKey, setTabKey] = useQueryParam<TabKey>('tab', (value) => value as TabKey);
  const [deviceRemoved, setDevicesRemoved] = useQueryParam('deviceRemoved', Boolean);
  const [addedDevices, setAddedDevices] = useQueryParam('addedDevices', (raw) => {
    const value = Number(raw);
    return value && !Number.isNaN(value) ? value : 0;
  });

  const toast = (content: typeof toastContent) => {
    setToastContent(content);
    triggerToast();
  };

  useCancelableEffect(() => {
    setDevicesRemoved(undefined, props.history);
    setAddedDevices(undefined, props.history);
  }, []);

  useCancelableEffect(() => {
    setTabKey(tabKey || 'home', props.history);
  }, [tabKey]);

  useEffect(() => {
    if (addedDevices) {
      toast(
        <>
          <strong>{addedDevices}</strong> device{addedDevices > 1 ? 's' : ''} added to My Devices
        </>
      );
    }
    if (deviceRemoved) {
      toast('Your device has been removed');
    }
  }, [addedDevices, deviceRemoved]);

  return (
    <RequireUser>
      <PageContainer>
        <Toast show={isToastVisible}>{toastContent}</Toast>
        <HideForTestGroup testGroupKey={ TestGroup.Warranty_Redesign }>
          <Heading1>Welcome Home!</Heading1>
        </HideForTestGroup>
        <TabNav
          isSticky
          tabs={tabs}
          tabProps={props}
          activeTabKey={tabKey}
          setActiveTabKey={(key: TabKey) => setTabKey(key, props.history)}
        />
      </PageContainer>
    </RequireUser>
  );
};

export default ProfilePage;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/ProfilePage.tsx